export default "__VITE_ASSET__BBY3j1En__"